import { Component, inject, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { IconLoaderService } from './service/icon-loader/icon-loader.service';
import { IconName } from './service/icon-loader/icon.register';

@Component({
  selector: 'app-icon',
  imports: [MatIcon],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  private readonly loader = inject(IconLoaderService);

  @Input({ required: true }) name!: IconName;
  @Input() size = 24;
  @Input() color: string = 'inherit';

  ngOnInit() {
    this.loader.ensure(this.name);
  }
}
